export const introduce = {
  text: '交易频率统计了每秒的交易总量',
  height: 1200,
};
